import {
  UPDATING_USER_PICTURE_ERROR,
  UPDATING_USER_PICTURE_SUCCESS,
  UPDATING_USER_PICTURE,
  SETTINGS_USER_CHANGE_INFO,
  SETTINGS_USER_CHANGE_LANGUAGE,
  SETTINGS_ALERT_SUCCESS,
  GDPR_EXPORT_DATA_REQUESTING,
  GDPR_EXPORT_DATA_SUCCESS,
  GDPR_EXPORT_DATA_ERROR,
  GDPR_DELETE_ACCOUNT_SUCCESS,
  GDPR_DELETE_ACCOUNT_ERROR,
  GDPR_DELETE_ACCOUNT_REQUESTING,
  SHOW_ALERT,
  HIDE_ALERT,
} from "./constants";

import i18n from "../../i18n";
import { LOGOUT } from "../login/constants";
import { IProfileSettingsReducer } from "./types";

const getInitialPhoneLanguage = () => {
  return i18n.locale.includes("fr") ? "fr" : "en";
};

const INITIAL_STATE: IProfileSettingsReducer = {
  profileTabSelected: "",
  alertMessage: {
    title: "",
    message: "",
    alertType: "success",
  },
  profileTabSizes: {},
  loading: false,
  manager: false,
  firstName: "",
  lastName: "",
  bio: "",
  birthDate: "",
  gdprRequesting: false,
  isReminderChecked: false,
  jobDescription: "",
  jobDuration: 0,
  numberOfReminders: 1,
  mbti: "",
  disc: "",
  firstReminderTime: {
    hour: 9,
    minute: 29,
  },
  secondReminderTime: {
    hour: 17,
    minute: 20,
  },
  thirdReminderTime: {
    hour: 11,
    minute: 50,
  },
  reminderTime: {
    hour: 14,
    minute: 30,
  },
  reminderDays: {
    1: true,
    2: true,
    3: true,
    4: true,
    5: true,
    6: false,
    7: false,
  },
  notifTime: {
    hour: 9,
    minute: 57,
  },
  paceGoal: 0,
  language: getInitialPhoneLanguage(),
};

export default (
  state: IProfileSettingsReducer = INITIAL_STATE,
  action,
): IProfileSettingsReducer => {
  switch (action.type) {
    case UPDATING_USER_PICTURE_SUCCESS:
      return {
        ...state,
        loading: false,
      };

    case UPDATING_USER_PICTURE_ERROR:
      return {
        ...state,
        loading: false,
      };

    case UPDATING_USER_PICTURE:
      return {
        ...state,
        loading: true,
      };

    case SETTINGS_USER_CHANGE_LANGUAGE:
      return {
        ...state,
        language: action.payload,
      };

    case SETTINGS_USER_CHANGE_INFO:
      return {
        ...state,
        ...action.payload,
      };

    case GDPR_DELETE_ACCOUNT_REQUESTING:
    case GDPR_EXPORT_DATA_REQUESTING:
      return {
        ...state,
        gdprRequesting: true,
      };

    case GDPR_DELETE_ACCOUNT_SUCCESS:
    case GDPR_EXPORT_DATA_SUCCESS:
    case GDPR_DELETE_ACCOUNT_ERROR:
    case GDPR_EXPORT_DATA_ERROR:
      return {
        ...state,
        gdprRequesting: false,
      };

    case SHOW_ALERT: {
      const { title, message, alertType = "success" } = action.payload;
      return {
        ...state,
        alertMessage: {
          ...action.payload,
        },
        loading: false,
      };
    }

    case HIDE_ALERT: {
      return {
        ...state,
        alertMessage: {
          ...INITIAL_STATE?.alertMessage,
        },
        loading: false,
      };
    }

    case LOGOUT: {
      const language = state.language;
      return {
        ...INITIAL_STATE,
        language,
      };
    }

    default:
      return state;
  }
};
